import { render, staticRenderFns } from "./CPOImpoExpo.vue?vue&type=template&id=12d6b793&scoped=true&"
import script from "./CPOImpoExpo.vue?vue&type=script&lang=js&"
export * from "./CPOImpoExpo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d6b793",
  null
  
)

export default component.exports